import {
    StyleSheet
} from "react-native";
import type {
    RadarChartMeasuresConstantType,
    RadarChartDynamicStyleType,
    RadarChartMeasures
} from "./type";

export const RADAR_CHART_LEVELS = 4;

export const RADAR_CHART_MULTI_FILL_RATIO = 0.66;

export const RADAR_CHART_LABEL_BASELINE_SHIFT = 0.35;

export const getRadarChartMeasures = ({
    shapeConfigs,
    typography,
    borders,
    spaces
}: RadarChartMeasuresConstantType): RadarChartMeasures => {
    return {
        labelWeight: typography.labelSmallSize.fontWeight,
        dotRadius: shapeConfigs.chartDotSize / 2,
        haloWidth: shapeConfigs.chartHaloWidth,
        typography: typography.bodySmallSize,
        lineWidth: borders.chartLine,
        spacingSm: spaces.spacingSm,
        gridWidth: borders.line
    };
};

const stylesheet = StyleSheet.create({
    container: {
        width: "100%"
    }
});

export const useStyles = ({
    colors
}: RadarChartDynamicStyleType) => {
    const styles = {
        activeLabel: colors.content.text.high,
        spoke: colors.content.border.hover,
        grid: colors.content.border.subtle,
        label: colors.content.text.low
    };

    return styles;
};
export default stylesheet;
